import React from "react";
import { UscDisclaimerType } from "../../../../../../../shared-logic/types/UscCommonTypes";
import DisclaimerIconWrapper from "../../../../common/DisclaimerIconWrapper";
import Text, { type TextVariantsType } from "../../../../../../../shared-components/toyota/styles/atoms/Text";
import * as Styles from "./SpecItem.styles";
import type { UscColorType } from "../../../../../../../shared-components/toyota/styles/Variables.types";

type SpecItemPropsType = {
    title: string;
    value: string | number;
    unit?: string;
    variant?: TextVariantsType;
    tooltipReference?: string;
    hideDisclaimerIcon?: boolean;
    footnoteNumber?: number;
    color?: UscColorType;
};

const SpecItem = (props: SpecItemPropsType): JSX.Element => {
    const { title, value, unit, variant = "body-small-book", color = "grey-7" } = props;
    const { tooltipReference, hideDisclaimerIcon, footnoteNumber } = props;

    return (
        <Styles.SpecItem>
            <dt>
                <Text tag="span" variant={variant} color={color}>
                    {title}
                </Text>
            </dt>
            <dd>
                <Text tag="span" variant={variant}>
                    {value} {unit && unit}
                    {footnoteNumber && <Styles.Sup>{footnoteNumber}</Styles.Sup>}
                </Text>
                {!hideDisclaimerIcon && (
                    <DisclaimerIconWrapper
                        type={UscDisclaimerType.Spec}
                        // tooltipReference is the preferred way of retrieving a disclaimer
                        reference={tooltipReference || title.toLowerCase()}
                    />
                )}
            </dd>
        </Styles.SpecItem>
    );
};

export default SpecItem;
